import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PaginationComponent from '../Pagination';
import { getOrganizations } from '../../api';

const OrganizationList = () => {
    const navigate = useNavigate();
    const [organizations, setOrganizations] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const fetchOrganizations = useCallback(async () => {
        try {
            const response = await getOrganizations({ page: 1, limit: 10 });
            setOrganizations(response.data.data);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            console.error('Failed to fetch organizations', error);
        }
    }, []);

    useEffect(() => {
        fetchOrganizations();
    }, [fetchOrganizations]);

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this organization?')) {
            try {
               // await deleteOrganization(id);
                alert('Organization deleted successfully!');
                fetchOrganizations(); // Refresh the list
            } catch (error) {
                alert('Error deleting organization!');
            }
        }
    };

    const handleEdit = (id) => {
        navigate(`/edit-organization/${id}`);
    };

    return (
        <Box p={3}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">Organization List</Typography>
                <Button variant="contained" color="primary" onClick={() => navigate('/add-organization')}>
                    Add Organization
                </Button>
            </Box>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Contact Email</TableCell>
                        <TableCell>Contact Phone</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {organizations.map((org) => (
                        <TableRow key={org._id}>
                            <TableCell>{org.name}</TableCell>
                            <TableCell>{org.description}</TableCell>
                            <TableCell>{org.contactEmail}</TableCell>
                            <TableCell>{org.contactPhone}</TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={() => handleEdit(org._id)}
                                    sx={{ mr: 1 }}
                                >
                                    Edit
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    onClick={() => handleDelete(org._id)}
                                >
                                    Delete
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <PaginationComponent page={page} count={totalPages} onPageChange={setPage} />
        </Box>
    );
};

export default OrganizationList;
